import React, { useState } from 'react';
import styles from './ManagerLogin.module.css';
import strings from '../../../../globalization';
import activateArrow from '../../../../assets/images/login/activateArrow.png';
import { oneDineLogo } from '../../../../assets/images';
import backImg from '../../../../assets/images/Fireboard/back2_red.png';

const ManagerLogin = (props) => {
  const { onLoginPress, closePopup } = props;

  const [fieldValue, setFieldValue] = useState('');

  const login = () => {
    onLoginPress && onLoginPress(fieldValue);
    setFieldValue('');
  }

  return (
    <div className={styles.container}>
      <div className={styles.backButton} onClick={closePopup}>
        <img src={backImg} className={styles.backImage} alt="" />
      </div>
      <img src={oneDineLogo} className={styles.logo} alt="logo" />
      <div className={styles.wrapper}>
        <div className={styles.heading}>{strings.enterYourLoginId}</div>
      </div>
      <div className={styles.btnWrapper}>
        <input type="text" placeholder="" value={fieldValue} onChange={event => setFieldValue(event.target.value)} className={styles.textInput} />
        <button type="submit" onClick={login}>
          <img src={activateArrow} className={styles.activate} alt="activateArrow" />
        </button>
      </div>
    </div>
  );
}

export default ManagerLogin;
